// ----------------------------------------------------------------------
// <copyright file="Izenda.SearchResult.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
!(function () {
  var React = require('react');
  var connect = require('share/enhancers/Izenda.Connect');
  var GridLayout = require('share/components/controls/Izenda.GridLayout');

  var ReportTable = require('./Izenda.ReportTable');
  var GridLayoutReportPartTable = require('./Izenda.ReportPartTable');
  var ButtonGroup = require('./Izenda.ButtonGroup');

  var SearchResult = function (props) {
    var localization = props.localization;

    if (!props.reportPartSelection.searchStatus || !!props.reportPartSelectionStore.onSearchPromise) {
      return null;
    }
    return (
      <div>
        <GridLayout className="u_paddingAll">
          <GridLayout.Row>
            <GridLayout.Col>
              <strong>{localization.getText('SEARCH_RESULT_LABEL_SEARCH_RESULT')}</strong>
            </GridLayout.Col>
          </GridLayout.Row>
          <GridLayout.Row>
            <GridLayout.Col>
              {localization.getText('DASHBOARD_MESSAGE_SELECT_REPORT_THEN_SELECT_REPORT_PART')}
            </GridLayout.Col>
          </GridLayout.Row>
          <GridLayout.Row>
            <GridLayout.Col>
              <ReportTable {...props}/>
            </GridLayout.Col>
          </GridLayout.Row>
          <GridLayoutReportPartTable {...props} />
        </GridLayout>
        <GridLayout>
          <GridLayout.Row>
            <GridLayout.Col>
              <ButtonGroup {...props} />
            </GridLayout.Col>
          </GridLayout.Row>
        </GridLayout>
      </div>
    );
  };

  module.exports = connect()(SearchResult);
})();



// WEBPACK FOOTER //
// ./ui/share/components/controls/ReportPartSelectionPopup/Izenda.SearchResult.jsx